import { isGuideSupported } from "@expert/solve-tools";
import type { usePartner } from "@/sdk";
import { isDeviceActivationCall, isDeviceActivationIntent } from "./isActivation";

interface OpenActivationGuideProps {
    disableAutomaticOpen: boolean;
    intent?: string;
    isCustomerSession: boolean;
    isDeviceActivationGuideIntentAutoOpenEnabled: boolean;
    isGuideEnabled: boolean;
    isGuideOpen: boolean;
    isLoadingSimplrSession: boolean;
    partner: ReturnType<typeof usePartner>;
    supportNumberCalled?: string;
    queueName?: string;
}
export function shouldOpenActivationGuide({
    disableAutomaticOpen,
    intent,
    isCustomerSession,
    isDeviceActivationGuideIntentAutoOpenEnabled,
    isGuideEnabled,
    isGuideOpen,
    isLoadingSimplrSession,
    partner,
    supportNumberCalled,
    queueName,
}: Readonly<OpenActivationGuideProps>) {
    const isDeviceActivationGuideSupported = isGuideSupported("Device Activation");
    const isActivationCall = isDeviceActivationCall({ partner, supportNumberCalled, queueName });
    const isActivationIntent = isDeviceActivationIntent(intent);

    return (
        isGuideEnabled &&
        isDeviceActivationGuideSupported &&
        !isGuideOpen &&
        isCustomerSession &&
        !disableAutomaticOpen &&
        !isLoadingSimplrSession &&
        (isActivationCall || (isDeviceActivationGuideIntentAutoOpenEnabled && isActivationIntent))
    );
}
